//left in for ajax / anything else that
//is using jquery
var $body = $(".js-body");

const body = document.querySelector(".js-body"),
    header = document.querySelector(".js-header"),
    projectFilter = document.querySelector(".js-project-filter"),
    heroes = document.querySelectorAll('.js-hero'),
    articleContent = document.querySelector("#js-article-content"),
    articleScrollButton = document.querySelector(".js-scroll-button-article"),
    articleScrollButtonWrapper = document.querySelectorAll('.js-article-scroll-down'),
    expertiseScrollButton = document.querySelector(".js-expertise-button"),
    expertiseScrollSection = document.querySelector(".js-expertise-section"),
    teamScrollButton = document.querySelector(".js-team-button"),
    teamScrollSection = document.querySelector(".js-team-section"),
    vacanciesScrollButton = document.querySelector(".js-vacancies-button"),
    vacanciesScrollSection = document.querySelector(".js-vacancies-section"),
    socialScrollButton = document.querySelector(".js-social-button"),
    socialScrollSection = document.querySelector(".js-social-section"),
    practiceSubHeader = document.querySelector('.js-practice-subheader'),
    iconGroup = document.querySelectorAll(".js-loading-icons"),
    heroScrollDown = document.querySelector(".js-hero-button-scroll-down"),
    heroSlider = document.querySelector(".js-hero-slider"),
    loader = document.querySelector(".js-loader");


//   thisPage = body.dataset.page,
//   site = body.dataset.site;

let width = window.innerWidth,
    height = window.innerHeight,
    scrollPos = 0,
    headerTriggerPoint = header.clientHeight / 2;


